import React from 'react'
import Svg, { SvgProps, Circle } from 'react-native-svg'

interface CountdownCircularProgressProps extends SvgProps {
  progress: number
  size?: number
  trackWidth?: number
}

export const CountdownCircularProgress: React.FC<CountdownCircularProgressProps> = ({
  progress,
  size = 75,
  trackWidth = 5,
  ...props
}) => {
  const p = Math.max(0, Math.min(100, progress))
  const r = (size - trackWidth) / 2
  const strokeDashArray = 2 * Math.PI * r
  const strokeDashOffset = strokeDashArray * (p / 100)

  return (
    <Svg width={`${size}px`} height={`${size}px`} transform="scale(-1, 1) rotate(-90)" {...props}>
      <Circle
        cx="50%"
        cy="50%"
        r={r}
        strokeWidth={trackWidth}
        stroke="currentColor"
        fill="transparent"
        strokeDasharray={strokeDashArray}
        strokeDashoffset={strokeDashOffset}
      />
    </Svg>
  )
}
